import { useMemo } from 'react';
import flatten from 'lodash/flatten';
import shuffle from 'lodash/shuffle';
import zip from 'lodash/zip';
import { fg } from '@atlassian/jira-feature-gating';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';

const getInitialState = (project = 'Donut Plains'): string[] => {
	// TODO: extract to messages file once we've landed on a more definitive set of prompts
	const projectScopedPlaceholders = [
		`Find work items in project "${project}" that are assigned to me`,
		`What are the highest priority bugs in project "${project}"?`,
		`Stories in project "${project}" updated this month`,
		`Which tasks in project "${project}" don't have an assignee?`,
		`Find work items in project "${project}" that were created in the last 30 days`,
	];
	const projectScopedPlaceholdersOld = [
		`Find issues in project "${project}" that are assigned to me`,
		`What are the highest priority bugs in project "${project}"?`,
		`Stories in project "${project}" updated this month`,
		`Which tasks in project "${project}" don't have an assignee?`,
		`Find issues in project "${project}" that were created in the last 30 days`,
	];

	// TODO: extract to messages file once we've landed on a more definitive set of prompts
	const globalScopedPlaceholders = [
		'Work items about pizza forest with status rolling out',
		'Which epics are in progress?',
		"Find work items that I'm watching",
		'Work items reported by Mike and ordered by priority',
	];
	// TODO: extract to messages file once we've landed on a more definitive set of prompts
	const globalScopedPlaceholdersOld = [
		'Issues about pizza forest with status rolling out',
		'Which epics are in progress?',
		"Find issues that I'm watching",
		'Issues reported by Mike and ordered by priority',
	];

	// Randomize order of the placeholders above, making sure a project scoped placeholder always comes first
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return flatten(
		zip(
			shuffle(
				fg('jira-issue-terminology-update-m4')
					? projectScopedPlaceholders
					: projectScopedPlaceholdersOld,
			),
			shuffle(
				fg('jira-issue-terminology-update-m4')
					? globalScopedPlaceholders
					: globalScopedPlaceholdersOld,
			),
		),
	).filter((placeholder) => placeholder !== undefined) as string[];
};

export const usePlaceholders = (): string[] => {
	const { data: projectContext } = useProjectContext();

	return useMemo<string[]>(
		() => getInitialState(projectContext?.projectKey),
		[projectContext?.projectKey],
	);
};
